<template>
  <v-row>
    <v-col
      v-for="(item, index) in statsData"
      :key="index"
      cols="12"
      md="3"
      class="pt-0"
    >
      <v-card elevation="3">
        <v-row align="center" justify="center" class="px-4">
          <v-col cols="auto">
            <div class="grey--text mb-2 caption">
              {{ item.title1 }}
            </div>
            <div class="text-center">
              <span
                class="blue-grey--text text--darken-2 font-weight-bold pointer"
                @click="setDateAndFilter(item.title1)"
              >
                {{ item.value1 || 0 }}
              </span>
              <span>
                <v-icon
                  small
                  :class="item.function > 0 ? 'green--text' : 'red--text'"
                  v-text="getStatIcon(item.function)"
                >
                </v-icon>
              </span>
              <span
                class="caption"
                :class="item.function > 0 ? 'green--text' : 'red--text'"
              >
                {{ Math.abs(item.function) }}%
              </span>
            </div>
          </v-col>
          <v-divider vertical class="my-2 mx-1"></v-divider>
          <v-col cols="auto">
            <div class="grey--text mb-2 caption">{{ item.title2 }}</div>
            <div class="text-center">
              <span
                class="grey--text font-weight-bold pointer"
                @click="setDateAndFilter(item.title2)"
              >
                {{ item.value2 || 0 }}
              </span>
            </div>
          </v-col>
        </v-row>
      </v-card>
    </v-col>
    <v-col
      v-for="(item, index) in userStatsData"
      :key="index"
      cols="12"
      md="3"
      class="pt-0"
    >
      <v-card elevation="3">
        <v-row align="center" justify="center" class="px-4">
          <v-col cols="5">
            <div class="grey--text mb-2 caption">
              {{ item.title1 }}
            </div>
            <div class="text-center">
              <span class="green--text font-weight-bold pointer">
                {{ item.value1 || 0 }}
              </span>
            </div>
          </v-col>
          <v-divider vertical class="my-2 mx-1"></v-divider>
          <v-col cols="auto">
            <div class="grey--text mb-2 caption">{{ item.title2 }}</div>
            <div class="text-center">
              <span
                class="red--text text--darken-1 font-weight-bold pointer"
              >
                {{ item.value2 || 0 }}
              </span>
            </div>
          </v-col>
        </v-row>
      </v-card>
    </v-col>
  </v-row>
</template>
<script>
export default {
  data() {
    return {
      statsData: [],
      userStatsData: [],
      dateRangeMap: {
        "All Time": {
          startDate: "",
          endDate: ""
        },
        "Till Date": {
          startDate: "",
          endDate: this.$dayjs().format("YYYY-MM-DD")
        },
        Today: {
          startDate: this.$dayjs().format("YYYY-MM-DD"),
          endDate: this.$dayjs().format("YYYY-MM-DD")
        },
        Yesterday: {
          startDate: this.$dayjs()
            .subtract(1, "days")
            .format("YYYY-MM-DD"),
          endDate: this.$dayjs()
            .subtract(1, "days")
            .format("YYYY-MM-DD")
        },
        "This Month": {
          startDate: this.$dayjs()
            .startOf("month")
            .format("YYYY-MM-DD"),
          endDate: this.includeFuture
            ? this.$dayjs()
                .endOf("month")
                .format("YYYY-MM-DD")
            : this.excludeToday
            ? this.$dayjs()
                .subtract(1, "days")
                .format("YYYY-MM-DD")
            : this.$dayjs().format("YYYY-MM-DD")
        },
        "Last Month": {
          startDate: this.$dayjs()
            .startOf("month")
            .subtract(1, "month")
            .format("YYYY-MM-DD"),
          endDate: this.$dayjs()
            .startOf("month")
            .subtract(1, "days")
            .format("YYYY-MM-DD")
        },
        "This Week": {
          startDate: this.$dayjs()
            .startOf("week")
            .format("YYYY-MM-DD"),
          endDate: this.includeFuture
            ? this.$dayjs()
                .endOf("week")
                .format("YYYY-MM-DD")
            : this.excludeToday
            ? this.$dayjs()
                .subtract(1, "days")
                .format("YYYY-MM-DD")
            : this.$dayjs().format("YYYY-MM-DD")
        },
        "Last Week": {
          startDate: this.$dayjs()
            .startOf("week")
            .subtract(1, "week")
            .format("YYYY-MM-DD"),
          endDate: this.$dayjs()
            .startOf("week")
            .subtract(1, "days")
            .format("YYYY-MM-DD")
        }
      }
    };
  },
  created() {
    this.getStats();
    this.getUserStats();
  },
  methods: {
    getStats() {
      this.$axios
        .$get(`/api/v1/crm/logs/stats/`)
        .then(response => {
          const stats = response;
          this.statsData = [
            {
              title1: "Today",
              value1: stats.today && stats.today.toLocaleString(),
              function: this.getPercent(stats.today, stats.yesterday),
              title2: "Yesterday",
              value2: stats.yesterday && stats.yesterday.toLocaleString()
            },
            {
              title1: "This Week",
              value1: stats.this_week && stats.this_week.toLocaleString(),
              function: this.getPercent(stats.this_week, stats.previous_week),
              title2: "Last Week",
              value2:
                stats.previous_week && stats.previous_week.toLocaleString()
            },
            {
              title1: "This Month",
              value1: stats.this_month && stats.this_month.toLocaleString(),
              function: this.getPercent(stats.this_month, stats.previous_month),
              title2: "Last Month",
              value2:
                stats.previous_month && stats.previous_month.toLocaleString()
            }
          ];
        })
        .finally(() => {
          this.loading = false;
        });
    },
    getPercent(num1, num2) {
      if (num2 > 0) return Math.round(((num1 - num2) * 100) / num2);
      return num1;
    },
    getStatIcon(value) {
      if (value > 0) return this.$getIcon("mdiMenuUp");
      return this.$getIcon("mdiMenuDown");
    },
    getUserStats() {
      this.$axios
        .$get(
          `/api/v1/crm/logs/user-stat/?organiation=${this.$store.state.shell.currentOrganizationId}`
        )
        .then(response => {
          const userStats = response;
          this.userStatsData = [
            {
              title1: "Active Users",
              value1: userStats.active,
              title2: "Inactive Users",
              value2: userStats.inactive
            }
          ];
        })
        .finally(() => {
          this.loading = false;
        });
    },
    setDateAndFilter(choice) {
      const filter = {
        start_date: this.dateRangeMap[choice].startDate,
        end_date: this.dateRangeMap[choice].endDate
      };
      this.$emit("filters", filter);
    }
  }
};
</script>
